import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { LoginVerifyForm } from "@/features/auth/components/LoginVerifyForm";
import { TLoginVerifyLocationState } from "@/features/auth/types/loginVerifyForm";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

type TLoginVerifyPageProps = {};

export const LoginVerifyPage: FC<TLoginVerifyPageProps> = () => {
  const location = useLocation();
  const state = location.state as TLoginVerifyLocationState | null;

  if (!state?.pendingAuthToken || !state?.email || !state?.externalId) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  return (
    <Stack gap="50px" alignItems="center">
      <LoginLogo />
      <LoginVerifyForm state={state} />
    </Stack>
  );
};
